/**
 * Created by razial on 2026-04-16.
 */

const RewardedPromoIcon = function () {
    SideBarIcon.call(this, {
        animation: () => {
            const promotion = cleverapps.rewardedPromo && cleverapps.rewardedPromo.promotion;
            return promotion && promotion.getSidebarIconJson();
        }
    });
};

RewardedPromoIcon.prototype = Object.create(SideBarIcon.prototype);
RewardedPromoIcon.prototype.constructor = RewardedPromoIcon;

RewardedPromoIcon.prototype.resetState = function () {
    const location = cleverapps.meta.getSelectedLocation();
    if (!location.locationConfig.isMain || !connector.platform.isConnected()) {
        this.available = false;
        return;
    }

    const promotion = cleverapps.rewardedPromo.promotion;
    if (!promotion || (!promotion.isActive() && !promotion.isEnded())) {
        this.available = false;
        return;
    }

    this.available = true;

    this.setAttention(promotion.hasUnclaimedRewards());

    if (promotion.isEnded()) {
        this.setLeftTime(0);
        this.setTitle(Messages.get("Finished"));
        return;
    }

    const leftTime = promotion.getTimeLeft();
    if (leftTime > 0) {
        this.setLeftTime(leftTime);
        this.setTitle(undefined);
    } else {
        this.setLeftTime(0);
        this.setTitle(Messages.get("Finished"));
    }
};

RewardedPromoIcon.prototype.onPressed = function () {
    cleverapps.rewardedPromo.displayWindow();
};